module.exports = __webpack_public_path__ + "static/media/expand-alt.33149189.svg";